import Termly from 'termly-namespace'

import { unblockAddedTree } from './unblockers'


/**
 * @param {MutationRecord[]} mutations
 */
export default function unblockAddedNodes(mutations) {
  const decision = Termly.getReleaseDecision()

  // Nothing has been released yet, so there is nothing to keep releasing.
  if ( !decision ) {
    return
  }

  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach((node) => {
      // This skips over things like text nodes.
      if ( node.nodeType !== Node.ELEMENT_NODE ) {
        return
      }

      // A node the page added and took away again before this callback ran
      // has nothing left to release, and releasing a detached one throws.
      if ( !node.isConnected ) {
        return
      }

      unblockAddedTree(node, decision.categories)
    })
  })
}
